/**
 * @module components/BookSidebar
 * @author Charles Blais <charles.blais@canada.ca>
 * 
 * Station map display
 */

import React from 'react';
import queryString from 'query-string';

import { Button, Panel } from 'react-bootstrap';

import StationSummaryTable from './Table/StationSummaryTable';
import { useAppState } from '../contexts/AppStateProvider';
import { useLanguageState } from '../contexts/LanguageProvider';


const BookSidebar = () => {
  const [ state ] = useAppState();
  const [ lang ] = useLanguageState();

  let content = lang.summaryEmpty;
  if (state.selected) {
    content = (
      <>
        <StationSummaryTable style={{fontSize: '15px'}}
          {...state.selected}
        />
        <Button
          href={`?${queryString.stringify({
            network: state.selected.networkCode,
            station: state.selected.station.code,
            starttime: state.selected.station.starttime.format(state.datetimeFormat),
            ...(state.selected.station.endtime
              ? { endtime: state.selected.station.endtime.format(state.datetimeFormat) }
              : {}),
          })}`}
          bsSize='sm'
          style={{width:'100%'}}
        >
          {lang.moreDetails}
        </Button>
      </>
    )
  }
  
  return (
    <Panel bsStyle="info">
      <Panel.Heading>
        <Panel.Title componentClass="h2">{lang.summaryTitle}</Panel.Title>
      </Panel.Heading>
      <Panel.Body>{content}</Panel.Body>
    </Panel>
  )
}


export default BookSidebar;